// extracted by mini-css-extract-plugin
export var labelWrapper = "_fp-0";